// @flow
import { PeriodSurveysActionTypes } from './constants';

type PeriodSurveysAction = { type: string, payload: {} | string };

// common success
export const periodSurveysApiResponseSuccess = (actionType: string, data: any): PeriodSurveysAction => ({
    type: PeriodSurveysActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const periodSurveysApiResponseError = (actionType: string, error: string): PeriodSurveysAction => ({
    type: PeriodSurveysActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getPeriodSurvey = (id: string): PeriodSurveysAction => ({
    type: PeriodSurveysActionTypes.GET_PERIOD_SURVEY,
    payload: { id },
});

export const addPeriodSurvey = (periodSurvey:any):PeriodSurveysAction=>({
    type:PeriodSurveysActionTypes.ADD_PERIOD_SURVEY,
    payload:periodSurvey
})
export const updatePeriodSurvey = (periodSurvey:any):PeriodSurveysAction=>({
    type:PeriodSurveysActionTypes.UPDATE_PERIOD_SURVEY,
    payload:periodSurvey
})
export const deletePeriodSurvey = (id:string):PeriodSurveysAction=>({
    type:PeriodSurveysActionTypes.DELETE_PERIOD_SURVEY,
    payload:{id}
})

export const listPeriodSurveys = (params:any): PeriodSurveysAction => ({
    type: PeriodSurveysActionTypes.LIST_PERIOD_SURVEYS,
    payload: params,
});


export const resetPeriodSurveys = (): PeriodSurveysAction => ({
    type: PeriodSurveysActionTypes.RESET,
    payload: {},
});

